// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wizard-step-2 .info-alert[data-v-69f9e520] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-size: 0.95rem;\n}[dir] .wizard-step-2 .info-alert[data-v-69f9e520] {\n  border-radius: 8px;\n}\n.wizard-step-2 .info-alert svg[data-v-69f9e520] {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n}", ""]);
// Exports
module.exports = exports;
